import { timelineSteps } from "@/mocks/chigua";
import SectionHeading from "./SectionHeading";

export default function Timeline() {
  return (
    <section id="timeline" className="scroll-mt-16 bg-background-100/70 py-16 md:py-20">
      <div className="mx-auto grid max-w-content gap-10 px-4 md:px-6 lg:grid-cols-[0.8fr_1.2fr]">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <SectionHeading
            eyebrow="示范 · 事件时间线"
            title="一件瓜的来龙去脉，5 步讲清"
            desc="以近期热度较高的一起「带货口碑争议」为例，展示吃瓜图集如何把零散截图整理成可追溯的时间线。"
          />
          <div className="rounded-2xl border border-background-200 bg-background-50 p-5">
            <div className="flex items-center gap-3">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20cover%20art%20of%20a%20scales%20of%20debate%20in%20warm%20coral%20and%20cream%2C%20flat%20editorial%20illustration%2C%20minimal%2C%20no%20faces&width=400&height=300&seq=tl-cover-01&orientation=landscape"
                alt="带货口碑争议事件封面"
                className="h-20 w-28 rounded-xl border border-background-200 object-cover"
                width={112}
                height={80}
              />
              <div>
                <p className="text-xs text-foreground-400">归档事件 · #124092</p>
                <p className="mt-1 font-heading text-base font-bold leading-snug text-foreground-950">
                  头部主播带货口碑反转事件
                </p>
                <p className="mt-1 text-xs text-foreground-500">累计整理截图 46 张 · 回应 3 则 · 高赞评论 12 条</p>
              </div>
            </div>
            <a
              href="#latest"
              className="mt-4 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-4 py-2 text-sm font-medium text-primary-600 transition hover:bg-primary-100"
            >
              查看同类型时间线
              <i className="ri-arrow-right-line" />
            </a>
          </div>
        </div>

        <ol className="relative flex flex-col gap-0 border-l-2 border-secondary-200 pl-6 md:pl-8">
          {timelineSteps.map((s, i) => (
            <li key={s.title} className="relative pb-8 last:pb-0">
              <span
                className={`absolute -left-[31px] top-1 flex h-3.5 w-3.5 items-center justify-center rounded-full ring-4 ring-background-100 md:-left-[39px] ${
                  i === timelineSteps.length - 1 ? "bg-accent-500" : i === 0 ? "bg-primary-500" : "bg-secondary-300"
                }`}
              />
              <div className="flex flex-col gap-1 rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
                <span className="text-xs font-semibold uppercase tracking-wide text-primary-500">{s.time}</span>
                <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">{s.title}</h3>
                <p className="text-sm leading-relaxed text-foreground-500">{s.desc}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}